module.exports = __webpack_public_path__ + "assets/location-icon-0c2f76.svg";